import React from 'react';
import './styles.scss';
import classNames from "classnames";

function Expand({className, children, onClick}) {
    return (
        <button className={classNames({
            [className]: true,
            'mai-btn-expand': true,
        })}
                onClick={onClick}>
            {children}
        </button>
    );
}

export default Expand;
